module.exports = __webpack_public_path__ + "static/media/C.7bbc725e.png";